export const getRouteLabels = regionBusRoutes => {
  const routeLabels = regionBusRoutes.reduce((obj, busRoute) => {
    const { route, id } = busRoute;
    obj[id] = route;
    return obj;
  }, {});
  return routeLabels;
};

export const getRouteList = regionBusRoutes => {
  return regionBusRoutes.map((busRoute, index) => {
    const { route, id } = busRoute;
    return {
      id: 1000 + index,
      userId: 127,
      routeId: `${id}`,
      responsibility: 'PRIMARY',
      routeName: `${id}`,
      priorityOrder: 1,
      ctryCode: 'SG',
    };
  });
};

export const getDemoResultService = (routeData: any) => {
  const mappedResult = Object.entries(routeData).reduce(
    (obj, [routeId, routeItemData]: [any, any]) => {
      const { routeName, ladder } = routeItemData ?? {};
      const { direction } = ladder;
      const navigation = direction.map(directionItem => {
        const { value, stops } = directionItem;
        const firstStop = stops[0];
        const lastStop = stops[stops.length - 1];
        const routeHeadSign = `${firstStop.stopName} - ${lastStop.stopName}`;
        const mappedStops = stops.map(stopItem => stopItem.stopCode);
        const navigationItem = {
          direction: +value,
          routeHeadSign,
          path: [],
          stops: mappedStops,
        };
        return navigationItem;
      });
      const routeResult = {
        routeId,
        routeName,
        navigation,
      };
      obj[routeId] = routeResult;
      return obj;
    },
    {}
  );
  console.log('getDemoResultService', mappedResult);
  return mappedResult;
};
